import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setSubscriptionTeamList } from 'domains/subscription/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection) {
  const iamSubscriptionTeamList = yield call(connection.fetch.bind(connection), constants.RTM_IAM_SUBSCRIPTION_TEAM_LIST);
  if (iamSubscriptionTeamList.type === constants.RTM_IAM_SUBSCRIPTION_TEAM_LIST_OK) {
    const teams = iamSubscriptionTeamList.response.teams;
    yield put(setSubscriptionTeamList(teams));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedSubscriptionTeamListFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_IAM_SUBSCRIPTION_TEAM_LIST, catchErrors, sendRequest, connection);
}
